import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, OnInit, input } from '@angular/core';
import { DotCMSEditableTextComponent } from '@dotcms/angular';
import { DotCmsAnimationComponent } from 'src/app/extensions/dot-cms-uve/animations/animation/dot-cms-animation.component';
import { getFieldAnimation } from 'src/app/extensions/dot-cms-uve/animations/dot-cms-aniamtion.helper';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';

import { Banner, VideoContentlet } from '../../../models/dot-cms-uve-contentlet.model';
import { isInsideCarousel } from '../../../utils/dot-cms-uve-utils';

@Component({
  selector: 'custom-dot-cms-banner-link',
  templateUrl: './dot-cms-uve-banner-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./dot-cms-uve-banner-link.component.scss'],
  imports: [NgStyle, ServerHtmlDirective, DotCMSEditableTextComponent, DotCmsAnimationComponent],
})
export class DotCmsUveBannerLinkComponent implements OnInit {
  constructor(
    private elementRef: ElementRef // private gtmFacade: GoogleTagManagerFacade
  ) {}
  getFieldAnimation = getFieldAnimation;
  readonly contentlet = input<VideoContentlet | Banner>(undefined);
  bannerTitlekey: 'bannerTitle' | 'bannerVideoTitle' = 'bannerTitle';
  isInCarousel: boolean;
  sku: string;
  ngOnInit(): void {
    this.isInCarousel = isInsideCarousel(this.elementRef.nativeElement);
  }

  getBannerTitle(): string | null {
    if ('bannerTitle' in this.contentlet()) {
      return (this.contentlet() as Banner).bannerTitle;
    }
    if ('bannerVideoTitle' in this.contentlet()) {
      this.bannerTitlekey = 'bannerVideoTitle';
      return (this.contentlet() as VideoContentlet).bannerVideoTitle;
    }
    return null;
  }

  /*GTM - Select-Promotion */
  // selectPromotionGTMEvent() {
  //   const contentlet = this.contentlet();
  //   // this.gtmFacade.selectPromotionGTMEvent(contentlet?.link, contentlet);
  // }
}
